import {ResourceData} from "../common/resource/resource-service";
import {IEventUomType} from "./uom-models";

export class UomData extends ResourceData<IEventUomType> {
    constructor() {
        super("/v5/uom");
    }
}
